import React, { Component } from "react";
import GraphDataService from "../utils/GraphDataService";
import CytoscapeAdapter from "../utils/CytoscapeAdapter";
import FilterComponent from "./FilterComponent";
import TrailblazerStyleConfig from "../utils/CytoscapeConstants";
import LegendComponent from "./LegendComponent";

/**
 * This component renders the Trailblazer graph based on a NetworkRoute.
 */
export default class TrailblazerGraph extends Component {
    constructor(props) {
        super(props);

        this.cyRef = React.createRef();
        this.graphDataService = new GraphDataService();
        this.handleGraphDataChange = this.handleGraphDataChange.bind(this);
        this.handleApplyFilter = this.handleApplyFilter.bind(this);
        this.handleClearFilter = this.handleClearFilter.bind(this);
    }

    componentDidMount() {
        this.cytoscapeAdapter = new CytoscapeAdapter(this.cyRef);
        this.cytoscapeAdapter.initialize();

        // Setup interactions with the graph data service
        this.cytoscapeAdapter.setupInteractions(
            this.graphDataService,
            {
                onGraphDataChanged: this.handleGraphDataChange
            }
        );

        this.graphDataService.addChangeListener(this.handleGraphDataChange);

        // processes initial route
        if (this.props.route) {
            this.graphDataService.processRoute(this.props.route);
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.route !== this.props.route) {
            this.graphDataService.processRoute(this.props.route);
            this.cytoscapeAdapter.updateGraphData(this.graphDataService);
        }
    }

    componentWillUnmount() {
        if (this.cytoscapeAdapter) {
            this.cytoscapeAdapter.destroy();
        }

        this.graphDataService.removeChangeListener(this.handleGraphDataChange);
    }

    handleGraphDataChange() {
        const elements = this.graphDataService.getElements();
        this.cytoscapeAdapter.setElements(elements);
    }

    /**
     * Handles applying metadata filter from the FilterComponent
     * @param {string} metadataKey - The metadata key to filter by
     * @param {string} metadataValue - The metadata value to filter by
     */
    handleApplyFilter(metadataKey, metadataValue) {
        if (!metadataKey?.trim() || !metadataValue?.trim()) {
            return;
        }

        if (!this.graphDataService.hasGraphData()) {
            return;
        }
        this.graphDataService.resetGraph();
        this.graphDataService.filterByMetadataKeyValuePair(metadataKey.trim(), metadataValue.trim());
    }

    /**
     * Handles clearing the filter and resetting the graph data.
     */
    handleClearFilter() {
        if (this.graphDataService.hasGraphData()) {
            this.graphDataService.resetGraph();
            this.handleGraphDataChange();
        }
    }

    render() {
        return (
            <div>
                <div style={{ position: "relative" }}>
                    <div
                        ref={this.cyRef}
                        style={{
                            height: "800px",
                            width: "100%",
                            backgroundColor: "#e8e8e8"
                        }}
                    />
                    {LegendComponent(TrailblazerStyleConfig.DISPLAY_COLOR_NAMES)}
                </div>
                <FilterComponent
                    handleApplyFilter={this.handleApplyFilter}
                    handleClearFilter={this.handleClearFilter}
                />
            </div>
        );
    }
}